module.exports = __webpack_public_path__ + "img/cleaf_banner_customer.87e1ab91.jpg";